var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ed9d77b6-e180-46e5-a4fd-017383002860",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b5e89e01-50fc-495e-be24-60e9d7d6042b",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.55,13.92,12.07,16.4H9.87v2.2H7.67v2.2L5.47,23H1.07V18.6l9.09-9.08a6.6,6.6,0,1,1,8.23,4.4A6.78,6.78,0,0,1,14.55,13.92ZM19.9,8.83a3.3,3.3,0,1,0-4.66-4.66Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.bcc17fc1e56b9b22dfdeb2101be5173e.svg";
export { ForwardRef as ReactComponent };